import React from 'react';
import { termsOfServiceEn } from '../../content/legal/termsOfService.en';
import styles from './TermsOfService.module.css';

const TermsOfService: React.FC = () => {
  return (
    <div className={styles.terms}>
      <div className={styles.container}>
        <div className={styles.panel}>
          <header className={styles.header}>
            <h1 className={styles.title}>{termsOfServiceEn.title}</h1>
            <p className={styles.subtitle}>
              <strong>Last Updated:</strong> {termsOfServiceEn.lastUpdated}
            </p>
          </header>

          <div className={styles.content}>
            {termsOfServiceEn.sections.map((section) => (
              <section key={section.heading}>
                <h2>{section.heading}</h2>
                {section.subheading && <h3>{section.subheading}</h3>}
                {section.blocks.map((block, idx) => {
                  if (block.type === 'p') {
                    return <p key={`${section.heading}-p-${idx}`}>{block.text}</p>;
                  }

                  return (
                    <ul key={`${section.heading}-ul-${idx}`}>
                      {block.items.map((item) => (
                        <li key={`${item.label ?? 'item'}-${item.text}`}>
                          {item.label ? (
                            <>
                              <strong>{item.label}</strong>: {item.text}
                            </>
                          ) : (
                            item.text
                          )}
                        </li>
                      ))}
                    </ul>
                  );
                })}
              </section>
            ))}

            <hr className={styles.hr} />

            <footer className={styles.footer}>
              <p>
                <em>{termsOfServiceEn.footerNote}</em>
              </p>
            </footer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
